<app-metadata-page-wrapper #metadataPageWrapper [pageMetadataState]='pageMetadataState' [heading]='heading'>
    <app-metadata-render #metadataRender [pageMetadataState]='pageMetadataState'></app-metadata-render>
</app-metadata-page-wrapper>
